import { Mail, Phone, MapPin } from 'lucide-react';
import '../../styles/footer.css';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            {/* Brand Section */}
            <div className="footer-brand">
              <div className="footer-logo">
                <h3>SITCORP</h3>
                <span className="footer-logo-subtitle">International</span>
              </div>
              <p className="footer-description footer-mobile-hide">
                Leading global sourcing and manufacturing solutions provider, delivering 
                sustainable, high-quality products across multiple categories.
              </p>
            </div>

            {/* Quick Links */}
            <div className="footer-section footer-mobile-compact">
              <h4 className="footer-section-title">Quick Links</h4>
              <nav className="footer-nav">
                <a href="#hero" className="footer-link">Home</a>
                <a href="#mission" className="footer-link footer-mobile-hide">Mission</a>
                <a href="#capabilities" className="footer-link footer-mobile-hide">Capabilities</a>
                <a href="/products" className="footer-link">Products</a>
                <a href="#why-choose-us" className="footer-link footer-mobile-hide">Why Choose Us</a>
                <a href="#blog" className="footer-link footer-mobile-hide">Blog</a>
              </nav>
            </div>

            {/* Services */}
            <div className="footer-section footer-mobile-hide">
              <h4 className="footer-section-title">Services</h4>
              <nav className="footer-nav">
                <span className="footer-link">Sustainable Sourcing</span>
                <span className="footer-link">Product Development</span>
                <span className="footer-link">Quality Control</span>
                <span className="footer-link">Logistics & Fulfillment</span>
                <span className="footer-link">Cost Engineering</span>
              </nav>
            </div>

            {/* Contact Information */}
            <div className="footer-section">
              <h4 className="footer-section-title">Contact Us</h4>
              <div className="footer-contact-list">
                <div className="footer-contact-item-inline">
                  <Mail size={18} className="footer-icon" />
                  <a href="mailto:info@sitcorp.ae">info@sitcorp.ae</a>
                </div>
                <div className="footer-contact-item-inline">
                  <Phone size={18} className="footer-icon" />
                  <div className="footer-phone-group">
                    <a href="tel:+919840273300">+971586155995</a>
                  </div>
                </div>
                <div className="footer-contact-item-inline">
                  <MapPin size={18} className="footer-icon" />
                  <span>Dubai, UAE</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="footer-copyright">
              <p>&copy; {currentYear} SitCorp International. All rights reserved.</p>
            </div>
            <div className="footer-legal footer-mobile-hide">
              <a href="/privacy" className="footer-legal-link">Privacy Policy</a>
              <a href="/terms" className="footer-legal-link">Terms of Service</a>
              <a href="/compliance" className="footer-legal-link">Compliance</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;